<div class="test-enviroment-indicator" *ngIf="isTestEnviroment">
  <div class="d-flex flex-row justify-content-center align-items-center">
    <cnet-icon name="exclamation-triangle" [color]="'warning'" size="3"></cnet-icon>
    <p class="m-0"> AMBIENTE: {{enviroment}} </p>
  </div>
</div>
@if(!hideHeaderSignal()){
<app-header-toolbar />
}

<main class="main-container" [class.main-container-test-enviroment]="isTestEnviroment">

  @if(loading){
  <div class="main-container-loader" [class.main-container-loader-test-enviroment]="isTestEnviroment" [@fadeInOutAnimation]>
    <cnet-progress-spinner color="secondary" diameter="80" strokeWidth="6"></cnet-progress-spinner>
  </div>
  }
  <router-outlet #o="outlet"></router-outlet>
</main>

@if(!hideFooterSignal() && !isMobile){
  <app-footer  style="bottom: 25px;" appIframeRendered />
}

<app-config-tester *ngIf="isTestEnviroment" />
